module.exports = __webpack_public_path__ + "static/media/11pic.5cbf3bc3.jpg";